@let _title = title();
@let _description = sanitizedDescription();

<div class="se-side-details-note__container">
    @if (_title) {
    <div class="se-side-details-note__title-container">
        <span class="se-side-details-note__title">{{_title | translate}}</span>
    </div>
    }
    @if (_description) {
    <div class="se-side-details-note-description__container">
        <span class="se-side-details-note__description">{{_description}}</span>
    </div>
    }
</div>
